// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zkA6","importantInfo":"styles_importantInfo__sFkPE"};